import { combineStrings } from 'assets/utils/data/String';
import Model from 'models/Model';
import Product from '../product/Model.Product';
import ProductEnhancement from '../productEnhancement/Model.ProductEnhancement';
import insurerDeleteApi from './delete/Api.Insurer.Delete';
import insurerListApi from './list/Api.Insurer.List';
import insurerListPublicApi from './listPublic/Api.Insurer.ListPublic';
import insurerSaveApi from './save/Api.Insurer.Save';

export default class Insurer
  extends Model<Model.IInsurer>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IInsurer>
{
  id: number;
  name: string;
  code: string;
  streetAddress?: string;
  postalCode?: string;
  city?: string;
  provinceCode?: string;
  countryCode?: string;
  isActive?: boolean;
  products?: Product[];
  productEnhancements?: ProductEnhancement[];

  constructor(data: Partial<Model.IInsurer> | Utils.FormData<Model.IInsurer>, language?: Locale.Languages) {
    super({ products: [Product], productEnhancements: [ProductEnhancement] }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name || this.id.toString(),
      info: combineStrings(', ', this.streetAddress, this.postalCode, this.city, this.provinceCode, this.countryCode),
      subtitle: this.products?.map((p) => p.name).join(' | '),
    };
  }
  get fullAddress() {
    return combineStrings(', ', this.streetAddress, combineStrings(' ', this.postalCode, this.provinceCode));
  }
  get distributionKey(): string {
    return `Premium.${this.name}`;
  }
  static createInsurerAdjudications(insurers: Insurer[], currency: string): Model.IInsurerAdjudication {
    console.log(currency); // TODO: Fix
    return insurers?.reduce<Model.IInsurerAdjudication>((acc, insurer) => {
      acc[insurer.name] = null;
      return acc;
    }, {});
  }

  static async list(body?: Api.Core.Insurer.List.IRequest) {
    const { payload, ...rest } = await insurerListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new Insurer(it)),
        count: payload.count,
      },
    };
  }
  static async listPublic(req: Api.Core.Insurer.ListPublic.IRequest) {
    const { payload, ...rest } = await insurerListPublicApi(req);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new Insurer(it)),
        count: payload.count,
      },
    };
  }

  async save() {
    return await insurerSaveApi(this);
  }
  async delete() {
    return await insurerDeleteApi(this.id);
  }
}
